/**
 * Created by Rumyantsev Daniil on 25.07.2018.
 */
import {Pipe, PipeTransform} from '@angular/core';
import {DateService} from '../_service/date.service';
/*
 * Трансформирует дату в дату формата "dd.MM"
 *
 * Usage:
 *   date | shortDate
 * Example:
 *   {{ date | shortDate }}
 *   formats to: 20.07
 */
@Pipe({name: 'shortDate'})
export class ShortDatePipe implements PipeTransform {

  constructor(private dateService: DateService ){}

  transform(date: Date): string {
    return this.dateService.getTwoDigitDate(date);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/short-date.pipe.ts